export default function swapPlayerLocation() {
  const videoPromos = document.querySelectorAll('.video-promo');
  let throttled = false;
  const delay = 250;

  function swap() {
    if (videoPromos) {
      videoPromos.forEach((promo) => {
        const matchesLarge = window.innerWidth >= 1024;
        const video = promo.querySelector('.video-api-player');
        
        const mobileContainer = promo.querySelector('.video-promo__player--mobile');
        const desktopContainer = promo.querySelector('.video-promo__player--desktop');

        if (!matchesLarge) {
          if (mobileContainer.querySelector('.video-api-player') === null) {
            mobileContainer.append(video);
          }
  
          if (desktopContainer.querySelector('.video-api-player')) {
            desktopContainer.remove(video);
          }
        } else {
          if (desktopContainer.querySelector('.video-api-player') === null) {
            desktopContainer.append(video);
          }
          
          if (mobileContainer.querySelector('.video-api-player')) {
            mobileContainer.remove(video);
          }
        }
      });
    }
  }

  window.addEventListener('resize', function() {
    // if (!throttled) {
      swap();

    //   throttled = true;

    //   setTimeout(function() {
    //     throttled = false;
    //   }, delay)
    // }
  });

  swap();
}
